import axios from '@/libs/axios'

export default {

    namespaced: true,

    state: {
        platform: null,
        platforms: [],
    },

    getters: {

        platform(state) {
            return state.platform
        },
        platforms(state) {
            return state.platforms
        }
    },

    mutations: {

        SET_PLATFORM(state, value) {
            state.platform = value
        },
        SET_PLATFORMS(state, value) {
            state.platforms = value
        },
        UPDATE_PLATFORMS(state, data) {
            const index = state.platforms.findIndex(platform => platform.id == data.id)
            Object.assign(state.platforms[index], data);
        },
        ADD_PLATFORM(state, data) {
            state.platforms.push(data);
        }
    },

    actions: {

        async loadPlatform({ commit }, platformId) {
            try {
                const response = await axios.get(`api/platforms/${platformId}`);
                commit('SET_PLATFORM', response.data);
                return response.data;
            } catch (error) {
                console.error('Error loading platform:', error);
                throw error;  // Handle the error if needed
            }
        },
        loadPlatforms({ commit }) {
            return axios.get('api/platforms').then(response => {
                commit('SET_PLATFORMS', response.data.data)
            })
        },
        updatePlatform({ commit }, { formData }) {
            return axios.post(`api/platforms/${formData.get('id')}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then((response) => {
                console.log('response.data.data', response.data.data);
                commit('UPDATE_PLATFORMS', response.data.data)
            })
        },
        async searchPlatform({ commit }, keyword) {

            return await axios.post(`api/platforms/search`,
                {
                    keyword: keyword
                }
            ).then((response) => {
                console.log('response.data.data', response.data.data);
                return response.data;
            })
        },
        addPlatform({ commit }, { formData }) {
            return axios.post(`api/platforms`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }).then((response) => {
                commit('ADD_PLATFORM',  response.data.data);
            })
        }
    },
}
